import { render, staticRenderFns } from "./CarouselCardsEmpty.vue?vue&type=template&id=8aa6be5e&scoped=true&"
import script from "./CarouselCardsEmpty.vue?vue&type=script&lang=js&"
export * from "./CarouselCardsEmpty.vue?vue&type=script&lang=js&"
import style0 from "./CarouselCardsEmpty.vue?vue&type=style&index=0&id=8aa6be5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa6be5e",
  null
  
)

export default component.exports